mainHandler = {
    $homeContent : $('.home-content'),
    $backTop : $('[href="#back-top"]'),
    $main : $('main'),
    $html : $('html'),
    $header : $('header'),
    $sectionHero : $('.section-hero'),
    footer : {
        $largeFooter : $('#main-footer'), 
        $smallFooter : $('#small-footer'),
        $buttonFooterPanel : $('[data-footer-panel]'),
        $footerPanel : $('.footer-panel'),
        $openFooter : $('[href="#open-footer"]'),
        $animateFooter : $('[href="#animate-footer"]'),
        $footerAnimateContainer: $('.footer-animate-container'),
        $panelLargeFooter : $('.panel-large-footer'),
        $btnHide : $('.btn-hide'),
        $largeFooterContainer: $('.large-footer-container'),
    },
    navigation : {
        buttonClose : $('[href="#close-nav"]'),
        buttonOpen : $('[href="#open-nav"]'),
        navEl : $('.header-navigation'),
        $emptySidePanel: $('.empty-side-panel')
    },
    footerTop: 0,
    wHeight: 0,
    initLoad: true,

    footerScroll : function() {
        var self = this;
        var screenPos = $(document).scrollTop() + self.wHeight;
        var $imageContainer = self.footer.$largeFooter.find('.image-container');
        
        
        if (screenPos > (self.footerTop + (self.wHeight * 0.5) )) {
            $(self.footer.$smallFooter).removeClass('is-scrolling');
            self.$header.addClass('force-hide');
        } else {
            $(self.footer.$smallFooter).addClass('is-scrolling');
            self.$header.removeClass('force-hide');
        }

        /*
        if ($(document).scrollTop()+(self.wHeight * 0.2) > (self.footerTop)) {
            $imageContainer.find('.footer-logo').removeClass('active');
            $imageContainer.find('.footer-logo-full').addClass('active');
        } else {
            $imageContainer.find('.footer-logo').addClass('active');
            $imageContainer.find('.footer-logo-full').removeClass('active');
        }*/

    },

    resizeHomeContent : function() {
        var self = this;
        var screenHeight = $(window).outerHeight();
        var footerHeight = self.footer.$smallFooter.outerHeight();
        var newHeight = screenHeight - footerHeight;

        self.$homeContent.each(function(){
            $(this).css({
                'height' : newHeight,
                'min-height' : newHeight,
            });
            
            // if ($(this).hasClass('panel-menus')) {
            //     $(this).children().css({
            //         'height' : newHeight,    
            //     })
            // }
        })
    },

    openFooterPanel: function($obj){
        var self = this;
        var panel = $obj.data('footer-panel');
        var $closestPanel = $obj.closest('.panel-large-footer').find('.footer-panel');
        var isAnimateFooter = $('.large-footer-container').html() == '' ? true : false;
        
        $closestPanel = ($closestPanel.length == 0) ? self.footer.$footerPanel : $closestPanel;

        if (panel && $closestPanel.find('#'+panel).length > 0) {
            if (!isAnimateFooter && Foundation.MediaQuery.is("medium") && (($obj.attr('href') != '#open-footer-panel'))) {
                self.footer.$openFooter.click();
            }

            $closestPanel.children().addClass('hide');
            $closestPanel.find('#'+panel).removeClass('hide');
            animateHandler.triggerSmooth();    
            //if ((Foundation.MediaQuery.is("small only")) &&
            if (($obj.attr('href') == '#open-footer-panel')) {
                var hContent = $('#smooth-content').outerHeight();
                var hFooter =  $('.large-footer-container').outerHeight();
                var positionFooter = hContent - hFooter;
                var $content = $obj.closest('.panel-large-footer').closest('.content-container');

                if ($content.length > 0) {
                    animateHandler.smoother.scrollTo('#main-footer', true);
                    animateHandler.triggerSmooth();    
                } else {
                    self.$html.animate({
                        scrollTop : positionFooter
                    }, 500);
                    animateHandler.triggerSmooth();    
                }
                
            }
        } 
    },

    getScrollbarWidth: function() {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        document.body.appendChild(outer);
        const inner = document.createElement('div');
        outer.appendChild(inner);
        const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
        outer.parentNode.removeChild(outer);
        return scrollbarWidth;      
    },

    setDisableScrolling: function($disable = false){
        var self = this;
        var widthScroll = self.getScrollbarWidth();
        if ($disable) {
            self.$html.addClass('disable-scroll');
            if (Foundation.MediaQuery.atLeast("medium")) {
                self.$html.find('#smooth-content, .footer-nav-container').css('padding-right', widthScroll+'px');
            } 
        } else {
            self.$html.removeClass('disable-scroll');
            if (Foundation.MediaQuery.atLeast("medium")) {
                self.$html.find('#smooth-content, .footer-nav-container').css('padding-right', '0');
            }
        }
    },

    isIos: function(){
        var state = false;
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            if (browserRatio >=1.5) {
                state = true;
            }
        }
        return false;
    },
    init : function() {
        var self = this;
        var header = document.querySelector("header");
	    var headroom  = new Headroom(header);     
        var scrollTopTemp = 0;
        this.wHeight = $(window).height();  
        
        $('body').on('focus', 'input[type="text"], input[type="number"], input[type="tel"], input[type="email"], textarea', function() {
            let hContent = $('#smooth-content').outerHeight();
            let hFooter =  $('.large-footer-container').outerHeight();
            let $content = $(this).closest('.panel-large-footer').closest('.content-container');
            let $container = $(this).closest('.footer-animate-container');
            let top = 0;            
            let addonVal = self.footer.$largeFooter.position().top;
            
            if (addonVal < 0) {
                addonVal = 0;
            }

            if ($content.length > 0) {
                if (self.isIos) {
                    addonVal = -300;
                }    
                top = $(this).position().top + addonVal;
                
                $container.animate({
                    scrollTop : top
                }, 500);  
            } else {
                addonVal = 300;
                if (self.isIos) {
                    if ($(this).is("textarea")) {
                        addonVal = 370;
                    }
                }
                top = (hContent - hFooter) + $(this).position().top - addonVal;
                animateHandler.smoother.scrollTo(top, false);
            }
        });

        self.$main.on('click', '[data-footer-panel]', function(e) {
            if (!self.initLoad) {
                e.preventDefault();
                self.openFooterPanel($(this));
            }
        });

        self.navigation.buttonOpen.on('click', function(e) {
            e.preventDefault();
            self.navigation.navEl.addClass('showing');
            animateHandler.setDisplayHeaderFooter(false);
            self.setDisableScrolling(true);
            animateHandler.animateSlideEffect();
        });

        self.navigation.buttonClose.on('click', function(e) {
            e.preventDefault();
            self.navigation.navEl.removeClass('showing');
            animateHandler.setDisplayHeaderFooter(true);
            self.setDisableScrolling();
        });
        
        self.navigation.$emptySidePanel.on('click', function(e) {
            self.navigation.navEl.removeClass('showing');
            animateHandler.setDisplayHeaderFooter(true);
            self.setDisableScrolling();
        });

        
        self.navigation.navEl.find('.nav-item').on('click', function(e) {
            var href = $(this).attr('href');
            if (href.indexOf('#') == 0) {
                e.preventDefault();
                self.navigation.buttonClose.click();
    
                if ($(href).length > 0) {
                    animateHandler.smoother.scrollTo(href, true);
                }
                if (href == '#open-footer-panel') {
                    self.openFooterPanel($(this));
                }    
            }
        });

        self.footer.$openFooter.on('click', function(e) {
            e.preventDefault();
            var footTop = self.footer.$largeFooter.position().top + self.footer.$smallFooter.outerHeight();

            self.$html.animate({
                scrollTop : footTop
            }, 400);
        });

        self.$backTop.on('click', function(e) {
            e.preventDefault();

            self.$html.animate({
                scrollTop : 0
            }, 400);
        });

        self.footer.$animateFooter.on('click', function(e){
            e.preventDefault();
            var $content = self.footer.$footerAnimateContainer.find('.content-container');
        
            self.$main.toggleClass('show-footer');

            if (!self.$main.hasClass('show-footer')) {
                self.footer.$largeFooterContainer.append($content.children());
                $content.html('');
                self.setDisableScrolling();    
                
            } else {
                $content.append(self.footer.$panelLargeFooter);
                self.setDisableScrolling(true);
                // var $imageContainer = $content.find('.image-container');
                // $imageContainer.find('.footer-logo').removeClass('active');
                // $imageContainer.find('.footer-logo-full').addClass('active');        
            }
            animateHandler.triggerSmooth();    
        });

        $(document).on('click', 'a', function(e){
            var href = $(this).attr('href');
            if (href.charAt(0) == '#') {
                e.preventDefault();
                if (self.initLoad == true) {
                    animateHandler.scrollToFirstHeroSection();
                    self.initLoad = false;
                    var interval = 1310;
                    if (Foundation.MediaQuery.is("small")) {
                        interval = 1510;
                    }
                    setTimeout(() => {
                        $(this).click();
                    }, interval);
                } else {
                    if ($(href).length > 0) {
                        animateHandler.smoother.scrollTo(href, true);
                    }
                }
            } 
        })

        self.footer.$footerAnimateContainer.on('click', 'a', function(e){
            var href = $(this).attr('href');
            if (href.charAt(0) == '#') {
                if ((href != "#open-footer-panel") && (href != "#animate-footer")) {
                    var $content = self.footer.$footerAnimateContainer.find('.content-container');
                    self.$main.toggleClass('show-footer');
                    self.setDisableScrolling();
                    self.footer.$largeFooterContainer.append($content.children());
                    $content.html('');
                    animateHandler.triggerSmooth();    
                    if ($(href).length > 0) {
                        setTimeout(() => {
                            animateHandler.smoother.scrollTo(href, true);
                        }, 200);
                    }
                } else if (href == "#open-footer-panel") {
                    if (Foundation.MediaQuery.is("small only")) {
                        self.footer.$footerAnimateContainer.animate({
                            scrollTop : 0
                        }, 400);
                    }    
                }
            }
        })

        /*
        $(document).on('closeme.zf.reveal', '[data-reveal]', function () {
            scrollTopTemp = $(document).scrollTop();
        });
       

        $(document).on('open.zf.reveal', '[data-reveal]', function () {
            animateHandler.setDisplayHeaderFooter(false);
            if (animateHandler.smoother) {
                animateHandler.smoother.paused(true);
            }
            self.setDisableScrolling(true);
        });

        $(document).on('closed.zf.reveal', '[data-reveal]', function () {
            animateHandler.setDisplayHeaderFooter(true);
            self.setDisableScrolling();
            if (animateHandler.smoother) {
                animateHandler.smoother.paused(false);
            }
            if (Foundation.MediaQuery.is("small only")) {
                animateHandler.triggerSmooth();    
            }
        });
 */
        $(document).on('click', '[data-open-reveal]', function(){
            let id = $(this).data('open-reveal');
            let $obj = $('#'+id); 
            $obj.addClass('is-showing');

            setTimeout(() => {
                $obj.addClass('fade');
            }, 300);

            if (animateHandler.smoother) {
                animateHandler.smoother.paused(true);
                animateHandler.smoother2.paused(true);
            }
            self.setDisableScrolling(true);
        })

        $(document).on('click', '[data-close-reveal]', function(){
            $('.reveal').removeClass('fade');
            setTimeout(() => {
                $('.reveal').removeClass('is-showing');
                
                self.setDisableScrolling();
                if (animateHandler.smoother) {
                    animateHandler.smoother.paused(false);
                    animateHandler.smoother2.paused(false);
                }
            }, 300);
        })

        $('[data-reveal-custom]').appendTo('body');
        animateHandler.setDisplayHeaderFooter(true, true);
        
        $(window).on('load scroll', function() {
            self.footerScroll();
        });

        var tempWidth = window.innerWidth;
        var firstLoad = true;
        $(window).on('load resize', function() {
            if ((tempWidth != window.innerWidth) || (firstLoad)) {
                self.resizeHomeContent();
                firstLoad = false;  
            }
        });
    }
}